var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 20C9.65 20 11 18.88 11 17.5H5C5 18.88 6.35 20 8 20ZM14.12 13.18V8C14.12 5.13 12.1 2.68 9.41 2.07V1.41C9.41 0.61 8.8 0 8 0C7.2 0 6.59 0.61 6.59 1.41V2.07C3.91 2.68 1.88 5.13 1.88 8V13.18L0 15.06V16H16V15.06L14.12 13.18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.f0958c48fb995a63eaa00f5e2cb0b358.svg";
export { ForwardRef as ReactComponent };